// The help centre's sections (index.ts has the rest of the content model). Its own module so search.ts can use it
// without importing index.ts (which imports search.ts).

export type HelpSectionId = "photographers" | "photos" | "app";

/** Every section, in the order the platform lists them (the store has the same fixed list: api-support-kb model.js). */
export const HELP_SECTION_IDS = ["photographers", "photos", "app"] as const satisfies readonly HelpSectionId[];

/**
 * Sections with their own front door: the Photohawk app's help (/help/app) is kept apart from Photohawk Studio's and
 * the event-photo buyers' (owner, Nov 2026: Studio's help never links to or mentions the consumer app, and the app's
 * never mentions Studio). Such a section isn't on the /help hub (its blocks, its section links, its unfiltered search
 * and its "Popular articles"), its own pages search only it, its breadcrumbs start at the section, and related
 * articles never cross into or out of it. Its pages, sitemap entries and JSON-LD are otherwise like any section's.
 */
export const SEPARATE_SECTIONS: ReadonlySet<string> = new Set<HelpSectionId>(["app"]);
export const isSeparateSection = (id: string | undefined): boolean => !!id && SEPARATE_SECTIONS.has(id);
/** Whether two sections' articles may be linked to each other (search suggestions, related articles). */
export const sameHelpWall = (a: string, b: string): boolean => a === b || (!isSeparateSection(a) && !isSeparateSection(b));
